module.exports = __webpack_public_path__ + "static/media/Tomatoes – 1.13369e7f.jpg";